module.exports = __webpack_public_path__ + "static/img/mba-course.9d82fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/mba-course.png
// module id = aY2k
// module chunks = 2